import { useState } from 'react';

import ButtonCircular from '@deliveryhero/pd-cookbook/components/ButtonCircular';
import IcRiderChatSend from '@deliveryhero/pd-cookbook/components/Icons/IcRiderChatSend';
import Tooltip from '@deliveryhero/pd-cookbook/components/Tooltip';

import { format, parseISO } from 'date-fns';
import { Allowance } from 'services/api';
import getInterval from 'utils/get-interval/get-interval';

interface SendAllowanceEmailButtonProps
  extends Pick<Allowance, 'id' | 'welcome_email_sent_timestamp'> {
  handleSendAllowanceEmail: (allowance_id: Allowance['id']) => void;
}

export const SendAllowanceEmailButton = ({
  welcome_email_sent_timestamp,
  id: allowance_id,
  handleSendAllowanceEmail
}: SendAllowanceEmailButtonProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  let isDisabled = false,
    tooltipBody = 'Send allowance email to employees';

  if (welcome_email_sent_timestamp) {
    const interval = getInterval(welcome_email_sent_timestamp);

    isDisabled = interval.days !== undefined && interval.days === 0;
    tooltipBody = isDisabled
      ? `You can send this once every 24 hours. Last sent on ${format(
          parseISO(welcome_email_sent_timestamp),
          'MMM d, hh:mm a'
        )}`
      : tooltipBody;
  }

  return (
    <Tooltip
      isVisibleForAnimation={showTooltip}
      arrowAlignment="right"
      bodyText={tooltipBody}
      placement="top"
    >
      <div
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <ButtonCircular
          disabled={isDisabled}
          onClick={() => handleSendAllowanceEmail(allowance_id)}
          ariaLabel="send-allowance-email-button"
        >
          <IcRiderChatSend fill="brand-primary" />
        </ButtonCircular>
      </div>
    </Tooltip>
  );
};
